import { TradePanelTab } from "#/types/tradePanel";
import { buildURL } from "#/utils/buildURL";

const portfolio = "/portfolio";
const rewards = "/rewards";
const institutional = "/institutional";
const more = "/more";

export const routes = {
  options: (params?: { panelTab: TradePanelTab }) => buildURL("", "/", params),
  perps: "/perps",
  combo: "/combo",
  portfolio: {
    index: portfolio,
    api: `${portfolio}/api`,
    history: `${portfolio}/history`,
    settings: `${portfolio}/settings`,
    positions: `${portfolio}/positions`,
    openOrders: `${portfolio}/open-orders`,
  },
  rewards: {
    index: rewards,
    leaderboard: `${rewards}/leaderboard`,
  },
  institutional: {
    index: institutional,
    rewards: `${institutional}/rewards`,
    rfq: `${institutional}/rfq`,
  },
  more: {
    index: more,
    analytics: {
      overview: `${more}/analytics`,
      positioning: `${more}/analytics/positioning`,
    },
    docs: "https://docs.kyan.blue",
  },
  mobile: "/m",
} as const;
